(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PrintInvoiceInfoController', PrintInvoiceInfoController);

    PrintInvoiceInfoController.$inject = ['$state', '$timeout', '$scope', 'entity', '$stateParams', 'OrderBag', 'OrderBagCustom', 'ServiceItemCustom', 'ServiceTimeSessionInfoCustom', 'ServiceTimeSession', 'CustomerCustom', 'Customer', 'Principal', '$uibModal', '$rootScope', 'InvoiceInfo', '$window', 'CompanyCustom', '__config'];

    function PrintInvoiceInfoController($state, $timeout, $scope, entity, $stateParams, OrderBag, OrderBagCustom, ServiceItemCustom, ServiceTimeSessionInfoCustom, ServiceTimeSession, CustomerCustom, Customer, Principal, $uibModal, $rootScope, InvoiceInfo, $window, CompanyCustom, __config) {

        var vm = this;

        vm.invoiceInfo = entity;
        vm.companyUrl = null;
        vm.__config = __config;

        vm.closeModal = closeModal;
        vm.okModal = okModal;
        vm.openPrintPreview = openPrintPreview;


        $rootScope.$broadcast('hideNavBar');


        load();

        function load() {
            CompanyCustom.getCurrentCompany().query(function (result) {
                vm.company = result;
                setCompanyUrl();
            });
        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            if ($rootScope.fromState && $rootScope.fromState.name) {

                if ($rootScope.fromState.name == 'supplierPanel-v2.invoiceInfoList') {
                    $state.go('supplierPanel-v2.invoiceInfoList');
                    return;
                } else {

                    if ($rootScope.fromStateParams) {
                        $state.go($rootScope.fromState.name, {id: $rootScope.fromStateParams.id});
                        return;
                    } else {
                        $state.go($rootScope.fromState.name);
                        return;
                    }

                }
            }
            
            $state.go('supplierPanel-v2.invoiceInfoDetail', { id: vm.invoiceInfo.id });

        }

        function okModal() {
            openPrintPreview();
        }


        function openPrintPreview() {
            $window.print();
        }

        function setCompanyUrl() {
            if (vm.company && vm.company.keyUrl) {
                vm.planovinUrl = vm.company.keyUrl + '.' + vm.__config.domain;
                if (vm.company.hasDedicatedDomain && vm.company.domain) {
                    vm.companyUrl = vm.company.domain;
                } else {
                    vm.companyUrl = vm.company.keyUrl + '.' + vm.__config.domain;
                }
            }
        }
    }
})();
